"use strict";
/**
 * @module Serialisers
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A Serialiser for buffers values
 */
var BufferSerialiserClass = /** @class */ (function () {
    function BufferSerialiserClass() {
    }
    /**
     * @inheritdoc
     *
     * Assumes that the remainder of the input stream should be read
     * This does not store the length of the buffer, so beware
     */
    BufferSerialiserClass.prototype.read = function (bis) {
        return bis.readMany(bis.count - bis.pos);
    };
    /**
     * @inheritdoc
     */
    BufferSerialiserClass.prototype.write = function (bos, val) {
        bos.writeMany(val);
    };
    return BufferSerialiserClass;
}());
exports.BufferSerialiserClass = BufferSerialiserClass;
/**
 * The {@link BufferSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.BufferSerialiser = new BufferSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/serialisers/buffer-serialiser.js
// module id = 1874
// module chunks = 1